import { AST } from "./ir/ast";

export class RuntimeError extends Error {
    /**
     * Create a RuntimeError that can be used in the XLogoInterpreter.
     * @param message A string containing a message what the error is. This is the backup if no translationKey is given.
     * @param _ast The AST that caused the error. If the error is initialized without AST this can be set afterwards once.
     * @param translationKey If the error message can be localized this property is set. It can be used to retrieve the
     *                          localized string from the language service.
     * @param translationParameters The parameters for the localization. If translationKey is set this property is guarantied to be set.
     */
    constructor(
        message: string | undefined,
        private _ast: AST | undefined,
        public readonly translationKey?: string,
        public readonly translationParameters?: { [key: string]: string },
    ) {
        super(message);
        if (this.translationKey && !this.translationParameters) {
            this.translationParameters = {};
        }
    }

    public get ast(): AST | undefined {
        return this._ast;
    }
    public set ast(v: AST | undefined) {
        if (!this._ast) this._ast = v;
    }
}



// WEBPACK FOOTER //
// ./src/app/xlogo-parser/runtimeError.ts